import React, { FunctionComponent } from 'react';
import { Form } from '../../../../store/modules/application/types';
import FormDisplay from '../../../../components/FormDisplay';
import Loader from '../../../../components/Loader';
import { Citation } from '../../../../store/modules/citation/types';

type CitationDataProps = {
    editForm: Form;
    citationDetails: Citation;
    updateCitation: Function;
    isLoading: boolean;
};

const CitationData: FunctionComponent<CitationDataProps> = (props) => {
    const { citationDetails, editForm, isLoading, updateCitation } = props;

    const handleSave = (updatedCitation: Citation) => {
        updateCitation(updatedCitation, citationDetails.id);
    };
    if (isLoading) return <Loader />;

    return <FormDisplay form={editForm} record={citationDetails} handleSave={handleSave} />;
};

export default CitationData;
